import { ChangeDisplayOrderMsgOption, GridProp, OptColumn } from '@/pro/types';
import { formatCurrency } from '@/pro/utils/numberFormat';
import { getDisplayOrderHistoryColumn } from '@/pro/components/product/common/gridColums/ChangeHistory';
import { i18nForProduct } from '@/pro/utils/i18n';


// export function i18nForProduct(word: string, data?: string, useCommon?: boolean): string {
//   return convertToI18n('PRODUCT_ADD_', word, data, useCommon);
// }

export const gridOptions = (): GridProp => ({
  displayOptions: {
    showsRightArea: false,
    pageSizeKey: 'size',
  },
  header: {
    height: 33,
    align: 'center',
  },
  options: {
    columnOptions: {
      resizable: true,
      frozenCount: 3,
    },
    rowHeaders: [
      {
        type: 'checkbox',
      },
    ],
    scrollY: true,
    minBodyHeight: 60,
    bodyHeight: 420,
    rowHeight: 31,
    pageOptions: {
      useClient: true,
      type: 'scroll',
    },
  },
});

// 자동진열: rowNum 추가, displayOrder 삭제
export const autoColumn = (): OptColumn[] => [
  {
    header: 'PRODUCT_ADD_HEADER_NO',
    name: 'rowNum',
    width: 80,
    align: 'center',
    formatter: ({ row }) => `${row.history ? row.displayOrder : Number(row.rowKey) + 1}`,
  },
];
// 수동진열: displayOrder 추가, rowNum 삭제
export const manualColumn = (): OptColumn[] => [
  getDisplayOrderHistoryColumn('PRODUCT_ADD_DISPLAY_ORDER', 'displayOrder', 100),
];
export const columns = (): OptColumn[] => [
  // 상품번호
  {
    header: 'PRODUCT_ADD_PRODUCT_NO',
    name: 'productNo',
    width: 120,
    align: 'center',
  },
  // 상품명
  {
    header: 'PRODUCT_COMMON_PRODUCT_NAME',
    name: 'productName',
    width: 400,
    align: 'center',
  },
  //판매가
  {
    header: 'PRODUCT_COMMON_SALE_PRICE',
    name: 'salePrice',
    width: 150,
    align: 'center',
    formatter: ({ value }) => `${formatCurrency(Number(value))}`,
  },
  //할인적용가
  {
    header: 'PRODUCT_ADD_DISCOUNT_PRICE',
    name: 'appliedImmediateDiscountPrice',
    width: 150,
    align: 'center',
    formatter: ({ value }) => `${formatCurrency(Number(value))}`,
  },
  //추가할인적용가
  {
    header: 'PRODUCT_COMMON_APPLIED_ADDITIONAL_DISCOUNT_PRICE',
    name: 'appliedAdditionalDiscountPrice',
    width: 150,
    align: 'center',
    formatter: ({ value }) => `${formatCurrency(Number(value))}`,
  },
  // 판매상태
  {
    header: 'PRODUCT_ADD_SALE_STATUS_TYPE',
    name: 'saleStatusType',
    width: 150,
    align: 'center',
    formatter: ({ value, row }) => {
      const periodText = row.isPeriodType && value === 'ON_SALE' ? `(${i18nForProduct('SALE_PERIOD')})` : '';
      return `${i18nForProduct(value.toString())}${periodText}`;
    },
  },
  // 판매설정태
  {
    header: 'PRODUCT_ADD_SALE_SETTING_STATUS_TYPE',
    name: 'saleSettingStatusType',
    width: 150,
    align: 'center',
    formatter: ({ value }) => i18nForProduct(value.toString()),
  },
  // 전시상태
  {
    header: 'PRODUCT_ADD_DISPLAY_YN',
    name: 'frontDisplayable',
    width: 150,
    align: 'center',
    formatter: ({ value }) => i18nForProduct(value ? 'DISPLAY_Y' : 'DISPLAY_N'),
  },
];

export const message: ChangeDisplayOrderMsgOption = {
  needOrigin: 'PRODUCT_ADD_PLZ_SELECT_PRODUCT_TO_MOVE',
  selectedTarget: 'PRODUCT_ADD_SELECTED_TARGET_MSG',
};
